import {Button, Modal} from 'react-bootstrap';
import React from 'react';
import EntityField from '../../../contentful/EntityField';
import EntityCollectionField from '../../../contentful/EntityCollectionField';

class MakeModelVariantSelectorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      make: props.make,
      makes: props.makes,
      model: props.model,
      models: props.models,
      variant: props.variant,
      variants: props.variants,

      makeIsSelected: !!props.make || (props.makes && props.makes.length),
      modelIsSelected: !!props.model || (props.models && props.models.length),
      variantIsSelected: !!props.variant || (props.variants && props.variants.length)
    };

    this.handleChange = this.handleChange.bind(this);
    this.createSearchParams = this.createSearchParams.bind(this);
  }

  handleChange(type, value) {
    const stateUpdate = {
      [type]: value
    };

    switch (type) {
      case 'make':
        stateUpdate.makeIsSelected = !!value;
        break;
      case 'makes':
        stateUpdate.makeIsSelected = value.length;
        break;
      case 'model':
        stateUpdate.modelIsSelected = !!value;
        break;
      case 'models':
        stateUpdate.modelIsSelected = value.length;
        break;
      case 'variant':
        stateUpdate.variantIsSelected = !!value;
        break;
      case 'variants':
        stateUpdate.variantIsSelected = value.length;
        break;
    }

    this.setState(stateUpdate);
  }

  createSearchParams(type) {
    if (type === 'model') {
      if (this.state.make !== undefined) {
        return {
          'fields.make.sys.id': this.state.make && this.state.make.id
        };
      }
      if (this.state.makes !== undefined) {
        return {
          'fields.make.sys.id[in]': this.state.makes.length && (this.state.makes.map((make) => make.id)).join(',')
        };
      }
    }

    if (type === 'variant') {
      if (this.state.model !== undefined) {
        return {
          'fields.model.sys.id': this.state.model && this.state.model.id
        };
      }
      if (this.state.models !== undefined) {
        return {
          'fields.model.sys.id[in]': this.state.models.length && (this.state.models.map((model) => model.id)).join(',')
        };
      }
    }

    return {};
  }

  render() {
    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          backdrop={true}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Bil</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.make !== undefined && <div className="form-group">
              <h3>Merke</h3>
              <EntityField
                name="make"
                contentType="bilmerker"
                value={this.state.make}
                onChange={this.handleChange}
                disabled={false}
                searchOnOpen={true}
              />
            </div>}
            {this.state.makes !== undefined && <div className="form-group">
              <h3>Merker</h3>
              <EntityCollectionField
                name="makes"
                value={this.state.makes || []}
                contentType="bilmerker"
                onChange={this.handleChange}
                disabled={false}
                searchOnOpen={true}
              />
            </div>}

            {this.state.model !== undefined && <div className="form-group">
              <h3>Modell</h3>
              <EntityField
                name="model"
                contentType="model"
                value={this.state.model}
                onChange={this.handleChange}
                // disabled={!this.state.makeIsSelected}
                searchOnOpen={true}
                searchParams={this.createSearchParams('model')}
              />
            </div>}
            {this.state.models !== undefined && <div className="form-group">
              <h3>Modeller</h3>
              <EntityCollectionField
                name="models"
                value={this.state.models || []}
                contentType="model"
                onChange={this.handleChange}
                // disabled={!this.state.makeIsSelected}
                searchOnOpen={true}
                searchParams={this.createSearchParams('model')}
                showArchived={this.props.showArchivedModels}
              />
            </div>}

            {this.state.variant !== undefined && <div className="form-group">
              <h3>Variant</h3>
              <EntityField
                name="variant"
                contentType="variant"
                value={this.state.variant}
                onChange={this.handleChange}
                // disabled={!this.state.modelIsSelected}
                searchOnOpen={true}
                searchParams={this.createSearchParams('variant')}
              />
            </div>}
            {this.state.variants !== undefined && <div className="form-group">
              <h3>Varianter</h3>
              <EntityCollectionField
                name="variants"
                value={this.state.variants || []}
                contentType="variant"
                onChange={this.handleChange}
                // disabled={!this.state.modelIsSelected}
                searchOnOpen={true}
                searchParams={this.createSearchParams('variant')}
              />
            </div>}
          </Modal.Body>

          <Modal.Footer>
            <Button
              bsStyle="success"
              className="pull-left"
              onClick={() => this.props.onChange({
                make: this.state.make,
                makes: this.state.makes,
                model: this.state.model,
                models: this.state.models,
                variant: this.state.variant,
                variants: this.state.variants
              })}
            >
                Bruk
            </Button>
            <Button
              bsStyle="primary"
              onClick={this.props.onHide}
            >
                Avbryt
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

MakeModelVariantSelectorModal.defaultProps = {
  show: true
};

export default MakeModelVariantSelectorModal;
